import { forwardRef } from '@chakra-ui/react';
import { SelectField } from './SelectField';

/**
 * @description  First year is the current year.
 *  Include also the next 5 years.
 */
export const SelectYear = forwardRef(({ ...rest }, ref) => {
  const currentYear = new Date().getFullYear();
  const totalYears = 6;

  const years = [currentYear.toString()];
  for (let i = 1; i < totalYears; i += 1) {
    years.push((currentYear + i).toString());
  }

  return <SelectField {...rest} options={years} inputRef={ref} />;
});
